import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TravelRoute } from 'src/app/models/travel-route';
import { dir } from '../route-create/route-create.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Expense } from 'src/app/models/expense';
import { ExpenseType } from 'src/app/models/expense-type';
import { ExpenseService } from 'src/app/services/expense.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ExpenseRoute } from 'src/app/expense-route';
import * as _ from 'lodash';
import { Customer } from 'src/app/models/customer';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-route-card',
  templateUrl: './route-card.component.html',
  styleUrls: ['./route-card.component.css']
})
export class RouteCardComponent implements OnInit {

  @Input() route:TravelRoute;
  mostrar:boolean = false;
  origin:dir;
  destination:dir;
  expense:Expense;
  expenseTypesMaps:any = [];
  typeExpenses: ExpenseType[] = [];
  loading: boolean = false;
  travelExpenses: ExpenseRoute[] = [];
  expense_type_id: number = 0;
  idRoute: number = 0;
  expense_id: number = 0;
  expenses:Expense[] = [];
  expensesAll: Expense[] = [];
  expensesMaps:any = [];
  price: number = 0;
  gas: number = 0;
  meters: number = 0;
  time: number = 0;
  routeName: string = '';
  @Output() search = new EventEmitter<string>();

  constructor(private modalService: NgbModal, private servExpense: ExpenseService, private toastr: ToastrManager, private utl: UtilitiesService) { }

  ngOnInit() {
    this.origin =  {
      lat: Number(this.route.source_customer_address.latitude),
      lng: Number(this.route.source_customer_address.longitude),
    };
    this.destination =  {
      lat: Number(this.route.target_customer_address.latitude),
      lng: Number(this.route.target_customer_address.longitude),
    };
    this.getData();
  }

  getData(){
    // this.loading = true;
    // forkJoin([this.servExpense.getExpenseTypes(), this.servExpense.getExpenses()]).subscribe(([expeType, expensess]) => {
    //   this.typeExpenses = expeType;
    //   _.forEach(this.typeExpenses, (et) => { this.expenseTypesMaps.push({id: et.id, text: et.name}); });
    //   this.expense_type_id = this.expenseTypesMaps[0].id;
    //   this.expenses = expensess;
    //   this.expensesAll = this.expenses;
    //   this.expenses = this.expenses.filter(b => b.expense_type_id == this.expense_type_id);
    //   _.forEach(this.expenses, (ex) => { this.expensesMaps.push({id: ex.id, text: ex.name}); });
    //   this.expense_id = (this.expensesMaps.length > 0) ? this.expensesMaps[0].id : 0;
    //   this.loading = false;
    // }, error => {
    //   this.toastr.warningToastr('Ocurrió un error al obtener los datos del viaje a actualizar.', '', {enableHTML: true});
    //   this.loading = true;
    // });
  }

  getExpensesTypes(){
    this.loading = true;
    this.servExpense.getExpenseTypes().then(response => {
      this.typeExpenses = response;
      _.forEach(this.typeExpenses, (et) => { this.expenseTypesMaps.push({id: et.id, text: et.name}); });
      this.expense_type_id = this.expenseTypesMaps[0].id;
      this.loading = false;
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      this.loading = false;
    });
  }

  getExpenses(){
    this.loading = true;
    this.servExpense.getExpenses().then(response => {
      this.expenses = response;
      this.expensesAll = this.expenses;
      this.expenses = this.expenses.filter(b => b.expense_type_id == this.expense_type_id);
      _.forEach(this.expenses, (ex) => { this.expensesMaps.push({id: ex.id, text: ex.name}); });
      this.loading = false;
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      this.loading = false;
    });
  }

  test(modal) {
    this.modalService.open(modal, { size: 'lg', windowClass: 'bigger' });
  }
  
  seeExpense(modal, exp:Expense) {
    this.expense = exp;
    this.modalService.open(modal, { size: 'lg', windowClass: 'bigger' });
  }

  updateRoute(modal, id:number){
    this.loading = true;
    this.idRoute = id;
    this.servExpense.getExpenseByRoute(this.idRoute).then(response => {
      this.travelExpenses = response;
      this.loading = false;
      this.routeName = this.travelExpenses[0].route_name;
      this.meters = this.travelExpenses[0].meters;
      this.time = this.travelExpenses[0].time;
      this.gas = this.travelExpenses[0].gas;
      this.modalService.open(modal, { size: 'lg', windowClass: 'bigger' });
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      this.loading = false;
    });
  }

  selectTypeExpense(event){
    if(event['value'] != null){
      this.expense_type_id = event['value'];
      let expenseHTML = (<HTMLInputElement>document.getElementById('expense_id'));
      this.expenses = this.expensesAll.filter(e => e.expense_type_id == this.expense_type_id);
      this.expensesMaps = [];
      _.forEach(this.expenses, (e) =>{ this.expensesMaps.push({id: e.id, text: e.name}); });
      expenseHTML.disabled = (this.expensesMaps.length > 0) ? false : true; //Sino trae gastos, entonces deshabilitamos
    }
  }

  selectExpense(event){
    if(event['value'] != null){
      this.expense_id = event['value'];
      this.price = this.expenses.find(e => e.id == this.expense_id).price;
    }
  }

  deleteExpense(id: number, expense_id: number){
    let travelExp = this.travelExpenses.filter(te => te.expense_id != expense_id);
    this.travelExpenses = travelExp;
  }

  addExpense(){
    if(!this.travelExpenses.find(e => e.expense_id == this.expense_id)){
      if(this.expense_type_id && this.expense_id && this.price){
        this.loading = true;
        let newExpenseRoute = new ExpenseRoute;
        newExpenseRoute.id = this.idRoute;
        newExpenseRoute.route_name = this.route.name;
        newExpenseRoute.expense_id = this.expense_id;
        newExpenseRoute.expense_name = this.expensesAll.find(e=> e.id == this.expense_id).name;
        newExpenseRoute.price = this.price;
        newExpenseRoute.expense_type_id = this.expense_type_id;
        newExpenseRoute.expense_type = this.expensesAll.find(e => e.expense_type_id == this.expense_type_id).expense_type.name;
        newExpenseRoute.type = this.expensesAll.find(e => e.expense_type_id == this.expense_type_id).expense_type.type;
        this.travelExpenses.push(newExpenseRoute);
        this.loading = false;
      }else{ this.toastr.infoToastr('Debes completar los campos necesarios.', '', {enableHTML: true}); }
    }else{ this.toastr.infoToastr('Este gastos ya ha sido agregado a la ruta. Elije otro.', '', {enableHTML: true}); }
  }

  updateTravelRoute(){
    this.loading = true;
    if(this.travelExpenses.length > 0){
      //Actualizar Rutas
      let meters = this.meters;
      let time = this.time;
      let gas = this.gas;
      _.forEach(this.travelExpenses, (te) => {
        te.meters = meters;
        te.time = time;
        te.gas = gas;
      });
      this.travelExpenses[0].route_name = this.routeName;
      this.servExpense.updateExpensesRoute(this.idRoute, this.travelExpenses).then(response => {
        this.travelExpenses = response;
        this.loading = false;
        this.defaultValues();
        this.modalService.dismissAll();
        this.search.emit("La ruta fue actualizada correctamente!!!");
      }, error => {
        this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
        this.loading = false;
      });
    }else{ this.toastr.infoToastr('Debes agregar por lo menos un gasto a la ruta.', '', {enableHTML: true}); }
  }

  defaultValues(){
    this.price = 0;
    this.meters = 0;
    this.time = 0;
    this.gas = 0;
    this.travelExpenses = [];
    this.expense_type_id = 0;
    this.idRoute = 0;
    this.expense_id = 0;
    this.routeName = '';
  }
}
